module.exports = __webpack_public_path__ + "d231bd1f6c06e3dd15831a9c81a7c435.png";